var map = {
	"./da-DK.json": [
		"../i18n/da-DK.json",
		"1_content_da-DK"
	],
	"./de-DE.json": [
		"../i18n/de-DE.json",
		"1_content_de-DE"
	],
	"./en-AU.json": [
		"../i18n/en-AU.json",
		"1_content_en-AU"
	],
	"./en-GB.json": [
		"../i18n/en-GB.json",
		"1_content_en-GB"
	],
	"./en-US.json": [
		"../i18n/en-US.json",
		"1_content_en-US"
	],
	"./es-ES.json": [
		"../i18n/es-ES.json",
		"1_content_es-ES"
	],
	"./fr-FR.json": [
		"../i18n/fr-FR.json",
		"1_content_fr-FR"
	],
	"./it-IT.json": [
		"../i18n/it-IT.json",
		"1_content_it-IT"
	],
	"./nl-NL.json": [
		"../i18n/nl-NL.json",
		"1_content_nl-NL"
	],
	"./pl-PL.json": [
		"../i18n/pl-PL.json",
		"1_content_pl-PL"
	],
	"./ru-RU.json": [
		"../i18n/ru-RU.json",
		"1_content_ru-RU"
	],
	"./sv-SE.json": [
		"../i18n/sv-SE.json",
		"1_content_sv-SE"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../i18n lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;